import { Injectable } from '@angular/core';
import {Item} from "../../models/Item";
import {ObjectConfig} from "../../models/ObjectConfig";
import {UiAdapterService} from "../uiAdapterService/ui-adapter.service";
import {timer} from "rxjs";
import {ObjectArrayComponent} from "../../classes/plugins/objectArrayPlugin/object-array-component/object-array.component";
import {ItemManagerService} from '@src/app/services/itemManager/item-manager.service';

@Injectable({
  providedIn: 'root'
})
export class ObjectsArrayService {

  constructor(private ui: UiAdapterService, private im: ItemManagerService) { }

  async groupItems(selectedItems: {[key:number]: Item}) {
    let minId = null;
    let newParentItem:Item = null;
    for (let i in selectedItems){
      if (!minId || i<minId){
        minId = i;
        newParentItem = selectedItems[i];
      }
    }

    let isNewParentItemContainArray = newParentItem.config.getInputByName('__objectArray'),
        isNewParentItemWasChangedArray = newParentItem.config.getInputProp('__objectArray', 'is_changed');

    //check new parent for another parent and remove it
    let parentItemRegroupPromise = new Promise((r)=>{
      if (newParentItem.config.getCopyParentId != null){
        let oldParent = this.im.getItemById(newParentItem.config.getCopyParentId);
        if (oldParent && !oldParent.config.getInputProp('__objectArray', 'is_changed')){
          newParentItem = oldParent;
          minId = newParentItem.getId();
          isNewParentItemWasChangedArray = false;
          isNewParentItemContainArray = true;
          return r();
        }
        newParentItem.getObservable(Item.SET_NEW_PARENT_FOR_OBJECT_ARRAY_COPY).next(null);
        timer(100).subscribe(()=>{
          newParentItem.getObservable('RELOAD_CHILD').next(true);
          r();
        })
        return;
      }
      r();
    })

    await parentItemRegroupPromise;

    let selectedItemsInMultiSelectExceptParent = Object.assign({}, selectedItems);
    delete selectedItemsInMultiSelectExceptParent[minId];

    let input = {'value': true, 'is_changed': true};
    newParentItem.config.assignInput('__objectArray', input);

    if (isNewParentItemContainArray && !isNewParentItemWasChangedArray){
      let copiesNumber = {x: newParentItem.getCounterValue(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_X)+1, y: newParentItem.getCounterValue(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_Y)+1};
      newParentItem.clearCounter(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_X);
      newParentItem.clearCounter(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_Y);
      //starts from 1 because first object - parent and counter display value like value+1;
      for (let i = 1; i < copiesNumber.x*copiesNumber.y; i++){
        newParentItem.incrementCounter(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_X);
      }
    }

     if (!isNewParentItemContainArray){
      newParentItem.clearCounter(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_X);
      newParentItem.clearCounter(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_Y);
     }


    //selectedItemsInMultiSelectExceptParent - copies
    for (let i in selectedItemsInMultiSelectExceptParent){
      let _item:Item = selectedItemsInMultiSelectExceptParent[i];
      if (_item.config.getTool().type != ObjectConfig.TYPE_FIXED_FIGURE){
        continue;
      }

      if (_item.config.isCopy && _item.config.getCopyParentId == minId){
        continue;
      }

      //check is copy a parent object?
      if (_item.config.getInputByName('__objectArray')){
        this.setObjectArrayItemAsCopy(_item, minId, newParentItem);
      //  maybe should reload as child
      }

      if (_item.config.isCopy){
        let parent = this.im.getItemById(_item.config.getCopyParentId);
        if (parent && !parent.config.getInputProp('__objectArray', 'is_changed')){
          this.setObjectArrayItemAsCopy(parent, minId, newParentItem);
        }
      }


      this.setNewParentForCopy(_item, minId);

      newParentItem.incrementCounter(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_X);
      // counter++;
    }

    // newParentItem.getSubject(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_SUBJECT).next({x: counter, y: counter});


    timer(1000).subscribe(()=>{
      newParentItem.getObservable('RELOAD_COMPONENT').next(true);
      this.ui.selectedItem$ = newParentItem;
    });
  }

  onDragEnd(item: Item, object:{oldPosition, object}){
    if (item.config.getInputProp('__objectArray', 'value')){
      item.getObservable('objectArrayDragEnd').next({item:item, object: object});
    }
  }

  private setNewParentForCopy(c: Item, parentId) {
    c.setMainSidebarItemVisibility(false);
    if (c.config.getCopyParentId!=null && c.config.getCopyParentId != parentId){
      return c.getObservable(Item.SET_NEW_PARENT_FOR_OBJECT_ARRAY_COPY).next(parentId);
    }
    c.config.copyParent = parentId;
    c.config.copyDirection = 'x';
    //maybe should add reload_child here
  }

  private setObjectArrayItemAsCopy(_item: Item, minId: any, newParentItem:Item) {
    let copiesOfCopy = this.im.getAllItemCopies(_item);
    copiesOfCopy.forEach((c)=>{
      this.setNewParentForCopy(c, minId);
      newParentItem.incrementCounter(ObjectArrayComponent.OBJECT_ARRAY_COUNTER_X);
    })
    _item.config.copyParent = minId;
    _item.config.removeInput('__objectArray');
    _item.getObservable('REMOVE_OBJECT_ARRAY_PARENT_LISTENERS').next(true);
  }
}
